import React from "react";

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => (
  <div className="flex flex-col items-center justify-center gap-3 rounded-md border border-dashed border-cardborder bg-gray-50 px-6 py-12 text-center">
    {icon && <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-brand shadow-sm">{icon}</div>}
    <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
    {description && (
      <div className="max-w-md text-sm text-gray-500">{description}</div>
    )}
    {action}
  </div>
);
